import { encryptWithAES, decryptWithAES } from '../utils/cryptography';
import { useCallback } from 'react';

export const useAESCipherAlgorithm = <T,>(passphrase: string) => ({
	encrypt: useCallback((data: T) => encryptWithAES(data, passphrase), [passphrase]),
	decrypt: useCallback((encryptedData: string) => decryptWithAES<T>(encryptedData, passphrase), [passphrase]),
});
